{
    "SecureMyOffer.section.propertyInformation": "FR: Property Information",
    "SecureMyOffer.section.residentialMarketValuation": "FR: Residential Market Valuation",
    "SecureMyOffer.section.requestedCoverage": "FR: Requested Coverage",
    "SecureMyOffer.section.preApprovalInformation": "FR: Pre-Approval Information",
    "SecureMyOffer.section.insuranceQuestions": "FR: Insurance Questions",
    "SecureMyOffer.section.notListedInformation": "FR: Not Listed Information",

    "SecureMyOffer.field.isRuralArea": "FR: Property is in Rural Area",
    "SecureMyOffer.field.saleStatus": "FR: What is the status of your property?",
    "SecureMyOffer.field.expectedListingDate": "FR: When do you expect to list the house?",
    "SecureMyOffer.field.intendedSalePrice": "FR: What is the intended sale price?",
    "SecureMyOffer.field.saleChannel": "FR: How do you intend to sell your property?",
    "SecureMyOffer.field.realtorChosen": "FR: Have you chosen a Realtor yet?",
    "SecureMyOffer.field.isSeller": "FR: Are you the seller?",
    "SecureMyOffer.field.conditionalPeriodExpiry": "FR: When does the conditional period expire?",
    "SecureMyOffer.field.conditionalClosingDate": "FR: When is the conditional closing date?",

    "SecureMyOffer.field.hasFirmOffer": "FR: Do you have a firm offer?",
    "SecureMyOffer.field.hasSecuredDeposit": "FR: Is your real estate agent or lawyer holding a deposit in trust?",
    "SecureMyOffer.field.securedDepositAmount": "FR: How much is the deposit?",
    "SecureMyOffer.field.currentClosingDate": "FR: What is the closing date?",
    "SecureMyOffer.field.saleAmount": "FR: What is the sale price?",

    "SecureMyOffer.field.residentialMarketValuationConfidenceRating": "FR: Confidence Rating",
    "SecureMyOffer.field.lowestValuationRange": "FR: Lowest Valuation Range",
    "SecureMyOffer.field.highestValuationRange": "FR: Highest Valuation Range",
    "SecureMyOffer.field.actualValuation": "FR: Actual Valuation",
    "SecureMyOffer.field.valuationDate": "FR: Date of Valuation",

    "SecureMyOffer.field.coverageCodeSelected": "FR: Selected coverage code",
    "SecureMyOffer.field.isBnplProgram": "FR: Buy Now Pay Later",
    "SecureMyOffer.field.hasNewHomePurchased": "FR: Has a new home been already purchased?",
    "SecureMyOffer.field.newHomePurchasedClosingDate": "FR: What is the closing date of the new home purchased?",
    "SecureMyOffer.field.isResidentialSingleUnit": "FR: Is Single-Unit Residential Home?",

    "SecureMyOffer.field.isPrimaryResidence": "FR: Is this a residential property and being used as the Seller's Primary Residence?",
    "SecureMyOffer.field.saleAmountConfirm": "FR: Please confirm the agreed upon sale price",
    "SecureMyOffer.field.isCondo": "FR: Is this property a condo or part of a condominium?",
    "SecureMyOffer.field.currentPropertySaleGoFirmDate": "FR: On what day did the offer \"go firm\"?",
    "SecureMyOffer.field.depositAmount": "FR: What is the value of the buyer's cash deposit being held in trust?",
    "SecureMyOffer.field.currentPropertySaleClosingDate": "FR: What is the closing date of the purchase and sale agreement?",
    "SecureMyOffer.field.usedRealEstateAgent": "FR: Were the Seller and Buyer each represented by a Licensed Real Estate Agent?",
    "SecureMyOffer.field.isRelatedToBuyer": "FR: Do the Buyer and Seller have any previous relationship?",
    "SecureMyOffer.field.buyerSellerRelationship": "FR: Describe the previous relationship",
    "SecureMyOffer.field.uncertainBuyer": "FR: Is there any reason to suspect that the buyer will not proceed with the purchase?",

    "SecureMyOffer.button.getValuation": "FR: Get Valuation",
    "SecureMyOffer.section.homeValueEstimate": "FR: Home Value Estimate",
    "SecureMyOffer.button.getEstimatedHomeValue": "FR: Get Estimated Home Value",

    "SecureMyOffer.field.lowestValuationRangeOverride": "FR: Lowest Valuation Range Override",
    "SecureMyOffer.field.highestValuationRangeOverride": "FR: Highest Valuation Range Override",
    "SecureMyOffer.field.actualValuationOverride": "FR: Actual Valuation Override"
}
